"use strict";exports.__esModule = true;exports.KeyboardMapKeys = void 0;var _KeyboardEventCodes = require("./KeyboardEventCodes");var _KeyboardMapKeys;





var STANDARD = 0; //KeyboardEvent.DOM_KEY_LOCATION_STANDARD;
var NUMPAD = 3; //KeyboardEvent.DOM_KEY_LOCATION_NUMPAD;

var KeyboardMapKeys = exports.KeyboardMapKeys = (_KeyboardMapKeys = {}, _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Unidentified] = [[0, 0]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.End] = [[35, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Escape] = [[27, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Equal] = [[187, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Backspace] = [[8, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Enter] = [[13, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.NumpadEnter] = [[13, NUMPAD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Home] = [[36, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Delete] = [[46, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Insert] = [[45, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.PageUp] = [[33, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.PageDown] = [[34, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Tab] = [[9, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.CapsLock] = [[20, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.KeyA] = [[65, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.KeyC] = [[67, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.KeyV] = [[86, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.KeyX] = [[88, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.NumpadDecimal] = [
[110, NUMPAD],
[46, NUMPAD]], _KeyboardMapKeys[

_KeyboardEventCodes.KeyboardEventCodes.NumpadSubtract] = [[109, NUMPAD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.NumpadDivide] = [[111, NUMPAD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Comma] = [[188, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Minus] = [[189, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Period] = [[190, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Slash] = [[191, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Backslash] = [[220, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.IntlBackslash] = [[226, STANDARD]], _KeyboardMapKeys[
_KeyboardEventCodes.KeyboardEventCodes.Space] = [[32, STANDARD]], _KeyboardMapKeys);